import { render, staticRenderFns } from "./IncomingRequests.vue?vue&type=template&id=fcb6d708"
import script from "./IncomingRequests.vue?vue&type=script&lang=js"
export * from "./IncomingRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports